import {
	TimeSeriesRawDataLatest,
	TimeSeriesRawDataReadings,
	TimeSeriesRawDataTotal,
} from '../../interfaces/api/timeseries';
import {
	getRawDataLatest,
	getRawDataReadings,
	getRawDataTotal,
	TimeSeriesRawDataParam,
} from '../../api/timeseries';

export async function fetchRawDataLatest(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataLatest[]> {
	try {
		return await getRawDataLatest(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchRawDataReadings(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataReadings[]> {
	try {
		return await getRawDataReadings(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchRawDataTotal(
	params: TimeSeriesRawDataParam
): Promise<TimeSeriesRawDataTotal[]> {
	try {
		return await getRawDataTotal(params);
	} catch (error) {
		throw error;
	}
}
